import { TraceabilityWithModule } from './TraceabilityWithModule';

export type { TypeTraceabilityWithModuleProps } from './types';
export default TraceabilityWithModule;
